import { useEffect, useState } from 'react'
import { api, type ContractTermSet } from '../../lib/api'
import { chipWords } from './contractTerms'
import '../../styles/docintel.css'

// One line in the vendor head saying what the vendor's contracts commit it to
// (release 3.3, documents lane D5): built only from readings a person accepted,
// so nothing here is the reader's guess. Until something is accepted it says
// how many readings wait for a decision; with nothing read it says nothing.
// A failed read says nothing either: the Documents tab carries the error.
//
// stamp is anything that changes when the vendor page is refreshed (the
// vendor as last read), so an acceptance in the Documents tab reaches this
// line without a reload.
export function ContractChip({ vendorId, stamp }: { vendorId: string; stamp?: unknown }) {
  const [set, setSet] = useState<ContractTermSet | null>(null)
  useEffect(() => {
    let live = true
    api.vendorContractTerms(vendorId).then(
      (s) => live && setSet(s),
      () => live && setSet(null),
    )
    return () => {
      live = false
    }
  }, [vendorId, stamp])
  const words = chipWords(set)
  if (!words) return null
  return (
    <p className="di-chip">
      {words}
    </p>
  )
}
